// @flow

export function filterForUnique (arr: Array<Object>, prop: string) : Array<Object> {
  return arr.filter((thing, index, self) =>
    self.findIndex((t) => { return t[prop] === thing[prop] }) === index
  )
}

export function sortByName (a: Object, b: Object) : Array<Object> {
  // allows case-insensitive sort
  return a.name.localeCompare(b.name)
}
